import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Play } from "lucide-react";
import { Avatar } from "../components/Avatar";
import { SongCard } from "../components/SongCard";
import { usePlayer } from "../context/PlayerContext";
import { http } from "../lib/api";

const CreatorsRow = ({ creators }) => (
  <div data-testid="following-creators" className="flex gap-5 overflow-x-auto scroll-thin pb-2">
    {creators.map((c) => (
      <Link key={c.user_id} to={`/autorius/${c.user_id}`} data-testid={`following-creator-${c.user_id}`} className="group flex flex-col items-center gap-2 w-20 shrink-0">
        <Avatar user={c} className="w-16 h-16 text-xl ring-2 ring-transparent group-hover:ring-[var(--c-orange)] transition-[box-shadow]" />
        <span className="text-xs text-zinc-400 truncate w-full text-center group-hover:text-white transition-colors">{c.name}</span>
      </Link>
    ))}
  </div>
);

export default function Following() {
  const p = usePlayer();
  const [data, setData] = useState(null);
  useEffect(() => { http.get("/feed").then((r) => setData(r.data)); }, []);

  return (
    <div className="space-y-10">
      <header className="flex flex-wrap items-end justify-between gap-6 rise">
        <div>
          <p className="text-xs uppercase tracking-[0.2em] text-[var(--c-orange)] font-semibold mb-4">Tavo srautas</p>
          <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold">Sekami</h1>
        </div>
        {data?.songs.length > 0 && (
          <button data-testid="feed-play-all" onClick={() => p.playAll(data.songs)}
            className="flex items-center gap-2 px-7 py-3 rounded-full bg-[var(--c-orange)] text-white font-semibold glow-orange hover:bg-[#ff7a26] transition-colors">
            <Play className="w-4 h-4" fill="currentColor" />Groti naujausias
          </button>
        )}
      </header>
      {!data && <div className="h-48 rounded-3xl shimmer" />}
      {data?.creators.length === 0 && (
        <div data-testid="following-empty" className="text-center py-20 rounded-3xl border border-dashed border-[var(--c-line)] text-zinc-400">
          Dar nieko nesekate. <Link to="/atrasti" className="text-[var(--c-orange)] hover:underline">Atraskite kūrėjų</Link> ir spauskite „Sekti“ jų puslapyje.
        </div>
      )}
      {data?.creators.length > 0 && <CreatorsRow creators={data.creators} />}
      {data?.creators.length > 0 && (
        <section className="space-y-5">
          <h2 className="font-display text-base md:text-lg font-bold">Naujausios dainos</h2>
          {data.songs.length === 0 && <p data-testid="feed-empty" className="text-sm text-zinc-500">Sekami kūrėjai dar nepaskelbė dainų.</p>}
          <div data-testid="feed-grid" className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 2xl:grid-cols-5 gap-x-5 gap-y-8">
            {data.songs.map((s, i) => <SongCard key={s.id} song={s} list={data.songs} index={i} />)}
          </div>
        </section>
      )}
    </div>
  );
}
